module.exports = __webpack_public_path__ + "static/media/i-cursor.9573c0bb.svg";